module.exports = __webpack_public_path__ + "static/media/react-native.214edac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/react-native.png
// module id = 176
// module chunks = 0